<template>
    <button
        type="button"
        @click="deletePost()"
        class="ml-1 hover:text-gray-800"
    >
        <svg
            class="h-5 w-5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
        >
            <title>삭제</title>
            <path d="M6 18L18 6M6 6l12 12" />
        </svg>
    </button>
</template>

<script>
export default {
    props: {
        masterId: Number,
    },

    methods: {
        async deletePost() {
            const option = {
                text: '정말 삭제할까요?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e02424',
                confirmButtonText: '삭제합니다',
                cancelButtonText: '취소',
            }

            const result = await this.$swal(option)

            if (!result.value) {
                return
            }

            try {
                const response = await axios.delete(`/masters/${this.masterId}`)
                location.href = `/masters`
            } catch (error) {
                this.toast(error.response.data.message, 'error', 5000)
            }
        },

        toast(message, type, timer) {
            this.$swal({
                text: message,
                icon: type || 'success',
                confirmButtonText: '확인',
                timer: timer || 3000,
            })
        },
    },
}
</script>
